/* Sepet çekmecesi: son eklenen ürünün marka / model / yılına göre çok satan öneriler.
   Çekmece her güncellendiğinde (Dawn innerHTML ile yeniden çizer) yeni .cfp-cart-recs kutusunu bulup doldurur. */
(function () {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  var cache = {};

  function buildUrl(box, withYear) {
    var u = new URL(box.dataset.url || '/collections/all', location.origin);
    u.searchParams.append('filter.p.m.custom.make', box.dataset.make);
    if (box.dataset.model) u.searchParams.append('filter.p.m.custom.model', box.dataset.model);
    if (withYear && box.dataset.year) u.searchParams.append('filter.p.m.custom.years', box.dataset.year);
    u.searchParams.set('sort_by', 'best-selling');
    u.searchParams.set('section_id', 'cfp-cart-recs');
    return u.pathname + u.search;
  }

  function getHtml(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { cache[url] = t; return t; });
  }

  function pick(html, exclude) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.prototype.slice.call(doc.querySelectorAll('.cfp-rec'))
      .filter(function (el) { return exclude.indexOf(el.dataset.productId) < 0; })
      .slice(0, 4);
  }

  function load(box) {
    if (box.dataset.state) return;
    box.dataset.state = 'loading';
    var exclude = (box.dataset.exclude || '').split(',');
    getHtml(buildUrl(box, true))
      .then(function (html) {
        var items = pick(html, exclude);
        // Aynı yıl aralığında yeterli ürün yoksa sadece marka + model ile dene
        if (items.length >= 2 || !box.dataset.year) return items;
        return getHtml(buildUrl(box, false)).then(function (h) {
          // Yıl aralığı genişletildi: başlıktaki yılı kaldır ki yanıltmasın
          var t = box.querySelector('.cfp-cart-recs__title');
          if (t && box.dataset.year) t.textContent = t.textContent.replace(' ' + box.dataset.year, '');
          return pick(h, exclude);
        });
      })
      .then(function (items) {
        var list = box.querySelector('.cfp-cart-recs__list');
        if (!items.length || !list) { box.hidden = true; box.dataset.state = 'empty'; return; }
        list.replaceChildren.apply(list, items);
        box.hidden = false;
        box.dataset.state = 'done';
      })
      .catch(function () { box.hidden = true; box.dataset.state = 'error'; });
  }

  // Üst çubuktaki sepet sayısını çekmecedeki adetlerle eşitle
  function syncCount() {
    var badge = document.querySelector('.cfp-util__cart span');
    if (!badge) return;
    var total = 0;
    drawer.querySelectorAll('input.quantity__input').forEach(function (i) { total += parseInt(i.value, 10) || 0; });
    if (drawer.querySelector('.drawer__inner.is-empty') || drawer.classList.contains('is-empty')) total = total || 0;
    badge.textContent = total;
  }

  function scan() {
    drawer.querySelectorAll('.cfp-cart-recs').forEach(load);
    syncCount();
  }

  new MutationObserver(function () { scan(); }).observe(drawer, { childList: true, subtree: true });
  scan();

  // Öneriden doğrudan sepete ekle
  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('.cfp-rec__add[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    var sections = typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer'];
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || !state.sections) { btn.disabled = false; return; }
        state.id = Number(btn.dataset.variantId);
        if (typeof drawer.renderContents === 'function') drawer.renderContents(state);
      })
      .catch(function () { btn.disabled = false; });
  });
})();
